import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import InvestorProfile from '../../InvestorProfile';
import FormAddressData from '../FormAddressData';
import InvestorHasInvalidState from '../InvestorHasInvalidState';
import InvestorNotFound from '../InvestorNotFound';
import InvestorDoesNotHavePendingCorrections from '../InvestorDoesNotHavePendingCorrections';
import InvalidInvestorId from '../InvalidInvestorId';
import uploadAddressProofErrorHandler from '../uploadAddressProofErrorHandler';
import AddressError from './AddressError';
class AddressAPI extends HundredBricksAPI {
    async updateAddress(payload) {
        const { proofFile, addressProofType, ...address } = payload;
        try {
            const formData = new FormAddressData(address);
            formData.append('proofFile', proofFile);
            formData.append('proofType', addressProofType);
            const { data } = await this.client.put('v2/profile/address', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVESTOR_NOT_FOUND':
                        throw new InvestorNotFound({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    default:
                        uploadAddressProofErrorHandler(error);
                }
            }
            if (error instanceof Error) {
                throw new AddressError('Unexpected error on updating address', { cause: error });
            }
            throw new AddressError(`Unexpected error on updating address: '${error}'`);
        }
    }
    async correctAddress(payload) {
        try {
            const formData = new FormAddressData(payload);
            const { data } = await this.client.post('v2/profile/address/correct', formData);
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_INVESTOR_ID':
                        throw new InvalidInvestorId({ cause: error });
                    case 'INVESTOR_NOT_FOUND':
                        throw new InvestorNotFound({ cause: error });
                    case 'INVESTOR_DOES_NOT_HAVE_PENDING_CORRECTIONS':
                        throw new InvestorDoesNotHavePendingCorrections({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    default:
                        throw new AddressError({ cause: error });
                }
            }
            if (error instanceof Error) {
                throw new AddressError('Unexpected error on correcting address', { cause: error });
            }
            throw new AddressError(`Unexpected error on correcting address: '${error}'`);
        }
    }
}
export default AddressAPI;
